import React, { } from "react";
import { View, Grid, useTheme, Text, Link, Card } from "@aws-amplify/ui-react";
import "../aipreset.css";
import { BsLink45Deg } from "react-icons/bs";

const LLM = () => {
    const { tokens } = useTheme();

    return (
        <>
            <View borderRadius="5px" maxWidth="100%" padding="0rem" minHeight="100vh">
                <Grid
                    templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                    templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
                    gap={tokens.space.xl}
                >

                    <View columnSpan={[1]} rowSpan={{ base: 1, large: 1 }}>
                        <Card className="aipresetlink">
                            <Link href="meta-llama/Meta-Llama-3.1-8B-Instruct.pdf" fontSize="sl" fontWeight="bold" textDecoration="none">
                                meta-llama/Meta-Llama-3.1-8B-Instruct <BsLink45Deg />
                            </Link>
                        </Card>
                    </View>

                    <View columnSpan={[1, 1, 3]} rowSpan={{ base: 3, large: 4 }}>
                        <Grid templateColumns={{ base: "1fr", large: "1fr 1fr 1fr 1fr" }} gap={tokens.space.xl}>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <Card className="aipresettask">
                                    <h4 className="mb-4">Task</h4>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#2d8bbb'}
                                    >
                                        Text Generation
                                    </Text>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#004aae'}
                                    >
                                        [Natural Language Processing]
                                    </Text>

                                </Card>
                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <Card className="aipresettask">
                                    <h4 className="mb-4">Developer</h4>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#38b6ff'}
                                        minHeight={50}
                                    >
                                        Meta
                                    </Text>

                                </Card>
                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <Card className="aipresettask">
                                    <h4 className="mb-4">Languages</h4>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#5273ff'}
                                    >
                                        English, German, French, Italian,
                                        Portuguese, Hindi, Spanish, Thai
                                    </Text>
                                </Card>

                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <Card className="aipresettask">
                                    <h4 className="mb-4"> </h4>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#2d8bbb'}
                                    >

                                    </Text>
                                    <Text
                                        variation="primary"
                                        as="p"
                                        lineHeight="1.5em"
                                        fontWeight={500}
                                        fontSize="1em"
                                        fontStyle="normal"
                                        textDecoration="none"
                                        color={'#004aae'}
                                    >

                                    </Text>
                                </Card>
                            </View>
                        </Grid>
                    </View>
                </Grid>

                <Grid className="mt-30"
                    templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                    templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
                    gap={tokens.space.xl}
                >
                    <View columnSpan={[1, 1, 1]} rowSpan={{ base: 3, large: 4 }}>
                        <Card className="aipresettask">
                            <h4 className="mb-4">Model Information</h4>
                            <Text
                                variation="primary"
                                as="p"
                                lineHeight="1.6em"
                                fontWeight={500}
                                fontSize="0.9em"
                                fontStyle="normal"
                                textDecoration="none"
                                color={'#0d0b0a'}
                            >
                                The Meta Llama 3.1 collection of multilingual large language models
                                (LLMs) is a collection of pretrained and instruction tuned generative
                                models in 8B, 70B and 405B sizes (text in/text out). The Llama 3.1
                                instruction tuned text only models (8B, 70B, 405B) are optimized for
                                multilingual dialogue use cases and outperform many of the available
                                open source and closed chat models on common industry
                                benchmarks.

                            </Text>
                        </Card>
                    </View>
                    <View columnSpan={[1, 1, 1]} rowSpan={{ base: 3, large: 4 }}>
                        <Card className="aipresettask">
                            <h4 className="mb-4">Use cases</h4>
                            <Text
                                variation="primary"
                                as="p"
                                lineHeight="1.6em"
                                fontWeight={500}
                                fontSize="0.9em"
                                fontStyle="normal"
                                textDecoration="none"
                                color={'#0d0b0a'}
                            >
                                The Meta Llama 3.1 collection of multilingual large language models
                                (LLMs) is a collection of pretrained and instruction tuned generative
                                models in 8B, 70B and 405B sizes (text in/text out). The Llama 3.1
                                instruction tuned text only models (8B, 70B, 405B) are optimized for
                                multilingual dialogue use cases and outperform many of the available
                                open source and closed chat models on common industry benchmarks.


                            </Text>
                        </Card>
                    </View>
                </Grid>
            </View>
        </>
    );
};

export default LLM;
